import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export function Reveal({ children, delay = 0, y = 32, className }) {
  return (
    <motion.div
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.8, delay, ease: EASE }}
      className={className}
    >
      {children}
    </motion.div>
  );
}

export function MaskedLines({ lines, className, lineClassName, delay = 0.15 }) {
  return (
    <div className={className}>
      {lines.map((line, i) => (
        <div key={i} className="overflow-hidden">
          <motion.div
            initial={{ y: "110%" }}
            animate={{ y: 0 }}
            transition={{ duration: 0.9, delay: delay + i * 0.12, ease: EASE }}
            className={lineClassName}
          >
            {line}
          </motion.div>
        </div>
      ))}
    </div>
  );
}

export function Marquee({ items, className }) {
  const row = items.join("  •  ") + "  •  ";
  return (
    <div className={`overflow-hidden border-y hairline bg-white ${className || ""}`} data-testid="editorial-marquee">
      <div className="animate-marquee flex whitespace-nowrap py-4">
        {[0, 1].map((n) => (
          <span key={n} className="font-mono-ed text-xs uppercase tracking-[0.25em] text-slate-500 pr-2">
            {row}{row}
          </span>
        ))}
      </div>
    </div>
  );
}
